<template>
  <div id="app">
    <div class="container">
      <div class="columns">
        <CForm @submitFields="updateCode" />
        <CPreview :arr="formFields" />
      </div>
    </div>
  </div>
</template>

<script>
import CForm from './components/CForm.vue'
import CPreview from './components/CPreview.vue'

export default {
  name: 'app',
  components: {
    CForm,
    CPreview
  },
  data: function() {
    return {
      formFields: []
    }
  },
  methods: {
    updateCode: function(fields){
      this.formFields = fields
    }
  }
}
</script>

<style>
@media(min-width: 600px){
  body{
    padding: 2rem;
  }
}
</style>
